class BadRequest extends Error {
    constructor(message = 'Bad Request.') {
      super(message)
      this.name = this.constructor.name
      this.status = 400
      this.fields = []
      Error.captureStackTrace(this, this.constructor)
    }

    /**
     * a method that adds an error to the fields array
     * @param {string} name name of the error
     * @param {string|number} code error code for this error
     * @param {string} message user friendly error message
     * @param {*} value value sent by the client
     * @param {string} location location where the error was found
     */
    addError(name, code, message, value, location) {
      this.fields.push({
        name,
        code,
        message,
        value,
        location
      })
    }

    removeError(name, code) {
      const idx = this.fields.findIndex(field => {
        return (field.name === name && field.code === code)
      })
      if (idx > -1) this.fields.splice(idx, 1)
    }

    clearErrors() {
      this.fields = []
    }

    hasErrors() {
      return (this.fields.length > 0)
    }
}

module.exports = BadRequest
